import { render, staticRenderFns } from "./SettledJD.vue?vue&type=template&id=42ae551f&scoped=true&"
import script from "./SettledJD.vue?vue&type=script&lang=js&"
export * from "./SettledJD.vue?vue&type=script&lang=js&"
import style0 from "./SettledJD.vue?vue&type=style&index=0&id=42ae551f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ae551f",
  null
  
)

export default component.exports